import { Crosshair, Compass, Network, Lightbulb, Map, Handshake } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";

const REASONS = [
  { icon: Crosshair, title: "Healthcare-Focused", desc: "Our communication and solutions are built around the healthcare sector." },
  { icon: Compass, title: "Practical Approach", desc: "We focus on understanding real requirements and developing practical solutions." },
  { icon: Network, title: "Professional Network", desc: "We aim to connect healthcare institutions, professionals and relevant stakeholders." },
  { icon: Lightbulb, title: "Knowledge Driven", desc: "We believe informed healthcare decisions begin with better understanding." },
  { icon: Map, title: "Regional Focus", desc: "Our growth vision covers healthcare markets across Madhya Pradesh, Chhattisgarh and Maharashtra." },
  { icon: Handshake, title: "Long-Term Relationships", desc: "We focus on professional relationships rather than one-time interactions." },
];

export const WhyUs = () => (
  <section id="why-us" className="relative bg-[#EAF3F8] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionTag index="06" label="Why Healthcare Solutions" />
        <h2 className="font-display mt-6 text-2xl font-bold tracking-tight text-[#0B3C5C] sm:text-3xl lg:text-4xl">
          Why Connect With Healthcare Solutions?
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {REASONS.map((r, i) => (
          <Reveal key={r.title} delay={i * 0.07}>
            <div
              data-testid={`why-card-${i + 1}`}
              className="group relative h-full overflow-hidden rounded-2xl border border-[#0B3C5C]/10 bg-white/70 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-teal-500/30"
            >
              <span className="pointer-events-none absolute -right-8 -top-8 h-24 w-24 rounded-full bg-[#5FA832]/5 blur-2xl transition-all duration-500 group-hover:bg-[#5FA832]/15" />
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#5FA832]/10 transition-colors duration-300 group-hover:bg-[#5FA832]/20">
                  <r.icon className="h-5 w-5 text-[#4C8F2F]" />
                </span>
                <span className="font-mono-x text-xs text-[#7E9AAC]">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <h3 className="font-display mt-5 text-lg font-bold text-[#0B3C5C]">{r.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#4A6B82]">{r.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
